module.exports = __webpack_public_path__ + "static/on-off-32ae2e79b4be6ce6db68fcdeffac79a1.wav";